import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CaseReady = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.5 0.5H3.5C2.94772 0.5 2.5 0.947715 2.5 1.5V14.5C2.5 15.0523 2.94772 15.5 3.5 15.5H12.5C13.0523 15.5 13.5 15.0523 13.5 14.5V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5Z"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8225 2.10352H4.17871V5.67063H11.8225V2.10352Z"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.22321 9.81327C7.07914 9.54002 7.0054 9.23518 7.00864 8.92629C7.01189 8.6174 7.09202 8.31419 7.24181 8.04402C7.70963 6.92763 6.32524 6.93193 5.60752 7.60004C5.3169 7.83907 5.12984 8.18113 5.08541 8.55479C5.04098 8.92845 5.14261 9.30483 5.36908 9.60535C5.74829 10.0533 6.25607 10.3738 6.82358 10.5234"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0935 11.4959C6.82031 11.6399 6.51556 11.7136 6.20677 11.7103C5.89797 11.7071 5.59484 11.627 5.32473 11.4773C4.20787 11.0095 4.21216 12.3939 4.88028 13.1116C5.1193 13.4022 5.46136 13.5893 5.83502 13.6337C6.20869 13.6781 6.58507 13.5765 6.88558 13.35C7.33367 12.9706 7.65417 12.4624 7.80359 11.8946"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7752 11.6238C8.91927 11.897 8.99301 12.2018 8.98976 12.5107C8.98652 12.8196 8.90638 13.1228 8.7566 13.393C8.28877 14.5113 9.67317 14.507 10.3909 13.8389C10.6808 13.5999 10.8675 13.2584 10.9119 12.8853C10.9563 12.5122 10.8551 12.1363 10.6293 11.836C10.2499 11.3879 9.74173 11.0674 9.17387 10.918"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9054 9.94378C9.17859 9.79979 9.48333 9.7261 9.79213 9.72934C10.1009 9.73259 10.4041 9.81268 10.6742 9.96238C11.7925 10.4302 11.7882 9.04581 11.1201 8.32809C10.8811 8.03814 10.5395 7.85153 10.1664 7.80711C9.79333 7.7627 9.41748 7.8639 9.11713 8.08965C8.66779 8.46833 8.34594 8.97616 8.19531 9.54415"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99885 11.9118C8.6573 11.9118 9.19107 11.378 9.19107 10.7196C9.19107 10.0611 8.6573 9.52734 7.99885 9.52734C7.34041 9.52734 6.80664 10.0611 6.80664 10.7196C6.80664 11.378 7.34041 11.9118 7.99885 11.9118Z"
        stroke={fill}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CaseReady.category = 'product-category';

CaseReady.displayName = 'CaseReady';
